'use strict';

(function () {
  angular.module('zp').directive('vendorContact', vendorContactDirective);

  /**ngInject */
  function vendorContactDirective($q, $window, mapConfig, mapService) {
    return {
      restrict: 'E',
      templateUrl: 'app/vendors/vendor.contact.html',
      link: link,
      scope: {
        vendor: '='
      }
    };

    function link(scope, element, attrs) {

      scope.mapMarkers = [];
      scope.mapOptions = angular.copy(mapConfig.mapOptions);
      scope.showDirections = showDirections;
      scope.openWebsite = openWebsite;

      /**Activate */
      (function () {
        scope.$watch('vendor', function () {
          if (!scope.vendor || !scope.vendor.location) {
            return false;
          }
          loadMapMarkers().then(setMapOptions);
          return true;
        }, true);
      })();

      function loadMapMarkers() {
        return $q.when(function () {
          scope.mapMarkers.push(scope.vendor.location);
        }());
      }

      function setMapOptions() {
        return $q.when(function () {
          scope.mapOptions.mapCenter = scope.mapMarkers.length ? scope.mapMarkers[0] : null;
          scope.mapOptions.disableDefaultUI = true;
          scope.mapOptions.zoomControl = true;
          scope.mapOptions.streetViewControl = false;
          scope.mapOptions.draggable = true;
          scope.mapOptions.scrollwheel = false;
          scope.mapOptions.disableDoubleClickZoom = true;
          return true;
        }());
      }

      function showDirections() {
        var destination = {
          address: scope.vendor.location.address,
          lat: scope.vendor.location.latitude,
          lng: scope.vendor.location.longitude
        };
        return mapService.navigate(null, destination);
      }

      function openWebsite(website) {
        var externalWebsite = website;
        if (website.indexOf('http') === -1) {
          externalWebsite = 'http://' + website;
        }
        $window.open(externalWebsite, '_blank');
      }
    }
  }
})();